<template>
  <b-container>
    <div class="d-flex justify-content-center mb-3">
      <h3>Types of Visits / Discounts</h3>
    </div>
    <b-row>
      <b-col>
        <vue-apex-charts
          type="bar"
          width="900"
          height="410"
          :options="chartOptions"
          :series="series"
        />
        <div class="text-center mt-2" v-if="valuesSummary">
          {{ valuesSummary }}
        </div>
      </b-col>
      <b-col class="d-flex justify-content-center flex-column align-items-center">
        <b-button variant="primary" class="m-2" @click="$emit('NC-show-modal')">
          NC Details
        </b-button>
        <b-button variant="primary" class="m-2" @click="$emit('NP-show-modal')">
          NP Details
        </b-button>
        <b-button variant="primary" class="m-2" @click="$emit('total-show-modal')">
          Total Details
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      valuesSummary: '',
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false, // Cambia a false si no deseas barras apiladas
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
            distributed: true, // Colores distintos para cada barra
            startingShape: 'rounded',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: 30, // Ajusta el valor para posicionar las etiquetas fuera de la barra
          style: {
            colors: ['#000000'], // Ajusta el color para mayor legibilidad
            fontSize: '12px',
            fontWeight: 'bold',
          },
          formatter: function (val) {
            return val.toFixed(0); // Mostrar sin decimales
          },
          position: 'right', // Posiciona las etiquetas a la derecha de las barras
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        xaxis: {
          categories: [], // Se actualizarán dinámicamente
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
      },
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.updateChart(newData);
      },
    },
  },
  methods: {
    updateChart(data) {
      // cant / total desde values (no data.length); contrato §6
      const categories = ['cant', 'ajustment', 'total']
      const num = v => {
        const n = parseFloat(v)
        return Number.isFinite(n) ? n : 0
      }
      const nc = data?.NC?.values || {}
      const np = data?.NP?.values || {}

      this.series = [
        { name: 'NC', data: categories.map(cat => num(nc[cat])) },
        { name: 'NP', data: categories.map(cat => num(np[cat])) },
      ]
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: { ...this.chartOptions.xaxis, categories },
      }
      this.valuesSummary = `NC: cant ${num(nc.cant)} · total ${num(nc.total)} · avg ${
        nc.avg_total ?? '—'
      }  |  NP: cant ${num(np.cant)} · total ${num(np.total)} · avg ${np.avg_total ?? '—'}`
    },
  },
};
</script>

<style scoped>
.d-flex {
  gap: 1rem; /* Espacio entre botones y otros elementos */
}
</style>

